import React from "react";
import ScenarioGenerator1 from '../functions/ScenarioGenerator1';

function Scenario1() {
  return (
    <div class="main scenario">
      <section class="maintext">
        <ScenarioGenerator1/>
      </section>
      <div className="floating-sidebar">
        <ul>
          <li><a href="/image"><button>Generate</button></a></li>
          <li><a href="/chat"><button>Visit</button></a></li>
          <li><a href="/scenario"><button>Play</button></a></li>
          <li><a href="/challenge"><button>Versus</button></a></li>
        </ul>
      </div>
    </div>
  );
}

export default Scenario1;
